import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import Scripts from "./Script";
import { Button, Modal, Row, Col } from "react-bootstrap";
import storage from "../../../../Storage";
import RangeCredit from "../../../Components/Game/Addons";
import Engine from "../Engine";
import { gameCoin } from "../../../../actions/gameCoin";
import { setWallet } from "../../../../actions/gameWallet";
import { setWinnerText, setMeToGame } from "../../../../actions/crashGame";
import { Event, __, isValidNumber, forceSatoshiFormat, User, wait, Game, sendNotfication, randomString, playWinSound, getServerTime } from "../../../../Helper";
import Menus from "./Menus";
import AutoBet from "./AutoBet";
import C from "../../../../Constant";
import './style2.css';

class ManualBet extends Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: null,
            buttonText: 'Bet',
            buttonType: 'btn-bet',
            barType: 'next-round',
            inputDisabled: false,
            buttonProgress: null,
            clicked: false,
            added: false,
            holding: false,
            showNext: true,
            payout: forceSatoshiFormat(storage.getKey('odd') ? storage.getKey('odd') : 3000.00),
            // payout: forceSatoshiFormat(storage.getKey('odd') ? storage.getKey('odd') : 5.00),
            token: storage.getKey('token') ? storage.getKey('token') : null,
            hotkey: storage.getKey('hotkey') ? storage.getKey('hotkey') : "OFF",
            auto: false,
            online_users: 0,
            bid: '',
            our_bid: '',
            activeTab: 'bet',
            activeTab2: 'bet2',
            amount: parseFloat(storage.getKey('lam')) || 10.00,
            secondBetAmount: parseFloat(storage.getKey('lam2')) || parseFloat(storage.getKey('lam')) || 10.00,
            im_in_game_1: false,
            im_in_game_2: false,
            isCashingOut1: false,
            isCashingOut2: false,
            buyDisabled: false,
            buyButtonText: 'Buy',
            sellButtonText: 'Sell',
            sellButtonType: 'btn-bet',
            sellDisabled: false,
            showSellAmount: true,
            isPlacingBet1: false,
            isPlacingBet2: false,
            buyTriggered: false,
            isLoadingBet1: false,
            isLoadingBet2: false,
            showWinNotification: false,
            winAmount: 0,
            tradeDuration: '10s',
            showDurationMenu: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleBuy = this.handleBuy.bind(this);
        this.handleSell = this.handleSell.bind(this);
        this.setBet = this.setBet.bind(this);
        this.wrapperRef = React.createRef();
        this.buyRef = React.createRef();
        this.lastClickTime = 0;
        this.handleClickOutside = this.handleClickOutside.bind(this);

        // Track locked duration/start for each active bet to prevent latency-induced drift
        this.betStartTime1 = null;
        this.betDuration1 = 0;
        this.betStartTime2 = null;
        this.betDuration2 = 0;
        this.activeSessionId1 = null;
        this.activeSessionId2 = null;
    }

    componentDidMount() {
        this._isMounted = true;
        const engine = Engine

        this.setState({ engine: engine })

        //Load Coin From Redux
        this.props.gameCoin();

        window.addEventListener('keypress', this.handleHotKey.bind(this));

        // Game Event
        engine.trigger.on("game_status", (data) => this.checkStatus(data));

        engine.trigger.on("busted_crash", () => this.checkBustedGame());

        // User Event
        engine.trigger.on("play_crash", data => this.handlePlay(data));
        engine.trigger.on("finish_crash", data => this.handleFinish(data));
        engine.trigger.on("error_crash", data => this.handleError(data));
        engine.trigger.on("stop_playing", () => this.stopManual());
        engine.trigger.on("auto_bet", data => this.handleAuto(data));
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.removeEventListener('keypress', this.handleHotKey.bind(this));
    }

    handleClickOutside(event) {
        if (this.state.showDurationMenu) {
            this.setState({ showDurationMenu: false });
        }

        let value = parseFloat(this.state.payout);

        if (value < 1.01)
            value = 3.00;

        if (isNaN(value))
            value = 3.00;

        if (value > 3000)
            value = 3000;

        this.setState({ payout: parseFloat(value).toFixed(2) });

        var amount = this.wrapperRef.current.value;

        if (amount === '') {
            amount = 10.00;
            this.setState({ amount: 10.00, secondBetAmount: 10.00 });
            storage.setKey('lam', 10.00);
            storage.setKey('lam2', 10.00);
        }

        if (parseFloat(amount) < 10.00) {
            amount = 10.00;
            this.setState({ amount: forceSatoshiFormat(10.00), secondBetAmount: forceSatoshiFormat(10.00) });
            storage.setKey('lam', forceSatoshiFormat(10.00));
            storage.setKey('lam2', forceSatoshiFormat(10.00));
        }

        if (parseFloat(amount) > 10000.00) {
            amount = 10000.00;
            this.setState({ amount: forceSatoshiFormat(10000.00), secondBetAmount: forceSatoshiFormat(10000.00) });
            storage.setKey('lam', forceSatoshiFormat(10000.00));
            storage.setKey('lam2', forceSatoshiFormat(10000.00));
        }

        if (parseFloat(amount) <= 0) {
            amount = 10.00;
            this.setState({ amount: forceSatoshiFormat(10.00), secondBetAmount: forceSatoshiFormat(10.00) });
            storage.setKey('lam', forceSatoshiFormat(10.00));
            storage.setKey('lam2', forceSatoshiFormat(10.00));
        }
        else {
            if (amount === "NaN") amount = 10.00;
            this.setState({ amount: forceSatoshiFormat(amount), secondBetAmount: forceSatoshiFormat(amount) });
            storage.setKey('lam', forceSatoshiFormat(amount));
            storage.setKey('lam2', forceSatoshiFormat(amount));
        }
    }

    handleInputChange(event) {
        let target = event.target;
        let value = target.value;
        let name = target.name;

        if (name === 'amount') {
            if (!isValidNumber(value)) return;
        }

        if (name === 'payout') {
            storage.setKey('odd', value);
            if (value >= 3000) {
                return;
            }
            else if (value === '') {
                sendNotfication("Please Input Minimum Cashout Value of 1.01", 'info', 'top-center');
            }
        }

        if (name === 'amount') {
            storage.setKey('lam', value);
            // Sync secondBetAmount if update is from the main amount input
            this.setState({ amount: value, secondBetAmount: value });
            storage.setKey('lam2', value);
        } else if (name === 'secondBetAmount') {
            storage.setKey('lam2', value);
            this.setState({ [name]: value });
        } else {
            this.setState({ [name]: value });
        }
    }

    handleTradeDurationChange = (value) => {
        this.setState({ tradeDuration: value, showDurationMenu: false });
    };

    toggleDurationMenu = () => {
        this.setState(prevState => ({ showDurationMenu: !prevState.showDurationMenu }));
    }

    durations = ['10s', '15s', '30s', '1m'];

    incrementDuration = () => {
        const currentIndex = this.durations.indexOf(this.state.tradeDuration);
        if (currentIndex < this.durations.length - 1) {
            this.setState({ tradeDuration: this.durations[currentIndex + 1] });
        }
    }

    decrementDuration = () => {
        const currentIndex = this.durations.indexOf(this.state.tradeDuration);
        if (currentIndex > 0) {
            this.setState({ tradeDuration: this.durations[currentIndex - 1] });
        }
    }

    getTradeDurationMs() {
        switch (this.state.tradeDuration) {
            case '15s': return 15000;
            case '30s': return 30000;
            case '1m': return 60000;
            // case '2m': return 120000;
            case '10s':
            default: return 10000;
        }
    }

    stopManual() {
        this.setState({ started: false, buyButtonText: 'Buy', inputDisabled: false });
        this.setDefaultButton();
    }

    checkStatus(data) {
        if (this._isMounted) {
            // console.log("Status Data | " + JSON.stringify(data));
            if (data.status === 'busted') {
                this.checkBustedGame();
            }
        }
    }

    handleAuto = (data) => {
        if (this._isMounted) {
            let { amount, payout } = this.state;
            console.log(amount + " - " + payout);

            if (!payout) return alert('payout is empty.');
            if (!amount) return alert('amount is empty.');

            this.setState({ amount: amount, secondBetAmount: amount, payout: payout, auto: true, buyButtonText: "Automatic" });
            storage.setKey('lam', amount);
            storage.setKey('lam2', amount);

            this.setState({
                added: false,
                inputDisabled: true,
                buyDisabled: true
            });

            this.setBet();
        }
    };

    handleError(data) {
        if (this._isMounted) {
            // if (data.our_gid == '0') {

            console.log("Error Data: ", data);

            this.props.setMeToGame(false);

            // Reset synchronous guards
            this._cashingOut1 = false;
            this._cashingOut2 = false;
            this._cashingOut = false; // Legacy if any
            this.betStartTime1 = null;
            this.betStartTime2 = null;
            this.betDuration1 = 0;
            this.betDuration2 = 0;

            this.setState({
                holding: false,
                added: false,
                inputDisabled: false,
                buyDisabled: false,
                sellDisabled: false,
                isPlacingBet1: false,
                isPlacingBet2: false,
                isLoadingBet1: false,
                isLoadingBet2: false,
                buyTriggered: false
            });

            if (this.buttonProgressInterval) {
                clearInterval(this.buttonProgressInterval);
                this.buttonProgressInterval = null;
            }
            this.setState({ buttonProgress: null }); // Keep state update for potential UI needs, though logic relies on class prop

            this.setDefaultButton();

            if (!__.isUndefined(data.code)) {
                if (data.code === 'credit')
                    this.props.setWallet(true, data.uid);
            }

            this.setState({ clicked: false })
            sendNotfication(data.message, 'danger', 'top-center');
            // }
        }
    }

    setDefaultButton = () => {
        if (this._isMounted) {
            if (this.buttonProgressInterval) {
                clearInterval(this.buttonProgressInterval);
                this.buttonProgressInterval = null;
            }
            this.setState({ buttonProgress: null });

            // Reset synchronous cashout guards
            this._cashingOut1 = false;
            this._cashingOut2 = false;

            this.setState({
                added: false,
                holding: false,
                inputDisabled: false,
                buttonType: 'btn-bet',
                buttonText: "Bet",
                barType: "next-round",
                showNext: true,
                im_in_game_1: false,
                im_in_game_2: false,
                isCashingOut1: false,
                isCashingOut2: false,
                buyDisabled: false,
                buyButtonText: this.state.auto ? "Automatic" : 'Buy',
                sellButtonText: 'Sell',
                sellButtonType: 'btn-bet',
                sellDisabled: false,
                showSellAmount: true,
                isPlacingBet1: false,
                isPlacingBet2: false,
                buyTriggered: false
            });
        }
    };

    setWaitingButton = () => {
        if (this._isMounted) {
            this.setState({
                added: true,
                inputDisabled: true,
                sellButtonType: 'btn-bet-success-waiting',
                barType: "next-round",
                showNext: true,
                sellDisabled: true,
                showSellAmount: false
            });
        }
    };

    setOutButton = () => {
        if (this._isMounted) {
            this.setState({
                inputDisabled: false,
                sellButtonType: 'btn-bet-success',
                barType: "next-round",
                showNext: true,
                im_in_game: false,
                sellDisabled: true,
                showSellAmount: false
            });
        }
    };

    setBet(slot = 1) {
        if (this._isMounted) {
            if (slot === 1) {
                if (this.state.isPlacingBet1) return;
                this.setState({ clicked: true, im_in_game_1: true, buyDisabled: true, isPlacingBet1: true });
            } else {
                if (this.state.isPlacingBet2) return;
                this.setState({ clicked: true, im_in_game_2: true, sellDisabled: true, isPlacingBet2: true });
            }

            let { engine, amount, payout, token, secondBetAmount, tradeDuration } = this.state;
            let { bid } = this.props;

            // Get current multiplier (exact point where user started trade)
            const currentMult = parseFloat(Game['current_amount']) || 1.00;

            engine.coin = 'kshs';
            engine.token = token;
            engine.amount = slot === 1 ? amount : (secondBetAmount || amount);
            engine.payout = parseInt(payout * 100) * parseInt(engine.amount);
            engine.odd = currentMult; // Set to exact entry point instead of payout configuration
            engine.bid = bid;
            engine.duration = this.getTradeDurationMs();

            console.log("TRADE DURATION MS", engine.duration)

            if (slot === 1) {
                engine.play();
                // Safety timeout for pending flag
                if (this._timeoutPlacing1) clearTimeout(this._timeoutPlacing1);
                this._timeoutPlacing1 = setTimeout(() => {
                    if (this._isMounted && this.state.isPlacingBet1) {
                        this.setState({ isPlacingBet1: false, isLoadingBet1: false, buyDisabled: false });
                    }
                }, 5000);
            } else {
                engine.play2();
                if (this._timeoutPlacing2) clearTimeout(this._timeoutPlacing2);
                this._timeoutPlacing2 = setTimeout(() => {
                    if (this._isMounted && this.state.isPlacingBet2) {
                        this.setState({ isPlacingBet2: false, isLoadingBet2: false, sellDisabled: false });
                    }
                }, 5000);
            }
        }
    }

    cashOut(slot = 1) {
        if (this._isMounted) {
            if (slot === 1 && this._cashingOut1) return;
            if (slot === 2 && this._cashingOut2) return;

            if (slot === 1) this._cashingOut1 = true;
            if (slot === 2) this._cashingOut2 = true;

            let { engine } = this.state;
            let currentOdd = Game['current_amount'] || 1.00;

            // console.log(`[CASHOUT] Firing cashOut for slot ${slot} at odd ${currentOdd}`);

            if (slot === 1) {
                // this.activeSessionId1 = null;
                this.betStartTime1 = null;
                this.betDuration1 = 0;
                this.setState({
                    im_in_game_1: false,
                    isCashingOut1: true,
                    isPlacingBet1: false,
                    isLoadingBet1: false,
                    buyDisabled: false
                });
                engine.finish(currentOdd, this.activeSessionId1);
            } else {
                // this.activeSessionId2 = null;
                this.betStartTime2 = null;
                this.betDuration2 = 0;
                this.setState({
                    im_in_game_2: false,
                    isCashingOut2: true,
                    isPlacingBet2: false,
                    isLoadingBet2: false,
                    sellDisabled: false
                });
                engine.finish2(currentOdd, this.activeSessionId2);
            }

            // Safety fallback
            const timeoutId = slot === 1 ? '_timeoutCash1' : '_timeoutCash2';
            if (this[timeoutId]) clearTimeout(this[timeoutId]);
            this[timeoutId] = setTimeout(() => {
                if (this._isMounted) {
                    if (slot === 1) this._cashingOut1 = false;
                    if (slot === 2) this._cashingOut2 = false;
                    this.setState(slot === 1 ? {
                        im_in_game_1: false,
                        isCashingOut1: false,
                        buyDisabled: false
                    } : {
                        im_in_game_2: false,
                        isCashingOut2: false,
                        sellDisabled: false
                    });
                }
            }, 3000);
        }
    }

    handlePlay(data) {
        // console.log("Trade Data | " + JSON.stringify(data));

        if (this._isMounted) {
            if (data.token === this.state.token) {
                this.props.setMeToGame(true);

                // Clear spinner and pending flag
                if (data.bType === 'BUY') {
                    if (this._timeoutPlacing1) clearTimeout(this._timeoutPlacing1);
                    this.setState({ isLoadingBet1: false, isPlacingBet1: false });
                    this.activeSessionId1 = data.sessionId;
                    this.betStartTime1 = getServerTime();
                    this.betDuration1 = this.getTradeDurationMs();
                } else if (data.bType === 'SELL') {
                    if (this._timeoutPlacing2) clearTimeout(this._timeoutPlacing2);
                    this.setState({ isLoadingBet2: false, isPlacingBet2: false });
                    this.activeSessionId2 = data.sessionId;
                    this.betStartTime2 = getServerTime();
                    this.betDuration2 = this.getTradeDurationMs();
                }

                // Add to engine activeTrades
                if (this.state.engine) {
                    const startTime = data.bType === 'BUY' ? this.betStartTime1 : this.betStartTime2;
                    const duration = data.bType === 'BUY' ? this.betDuration1 : this.betDuration2;

                    // Snap entryTime to the last chart data point's timestamp to prevent
                    // the entry marker from drifting ahead of the chart head due to network latency.
                    const graphPoints = this.state.engine.activeTrades.__graphPoints || [];
                    // Access graph points via a known global or fall back to startTime
                    // We'll snap to within the last few seconds: use startTime as the reference
                    // but clamp it to not be ahead of the most recently seen ticker timestamp
                    const lastKnownTicker = this.state.engine._lastTickerTimestamp || 0;
                    const snappedEntryTime = (lastKnownTicker > 0 && lastKnownTicker <= startTime)
                        ? lastKnownTicker
                        : startTime;

                    const newTrade = {
                        id: randomString(8),
                        amount: data.amount,
                        entryMult: parseFloat(data.entryPrice),
                        entryTime: snappedEntryTime,
                        expiryTime: snappedEntryTime + duration,
                        slot: data.bType === 'BUY' ? 1 : 2,
                        sessionId: data.sessionId
                    };
                    this.state.engine.activeTrades.push(newTrade);
                }

                this.startTimerInterval();
            }
        }
    }

    handleFinish(data) {
        if (this._isMounted) {
            if (data.token !== this.state.token) return;
            // console.log("finish crash " + JSON.stringify(data));

            // Match by sessionId first (most reliable), then fallback to bType/channel
            const matchesSession1 = this.activeSessionId1 && data.sessionId === this.activeSessionId1;
            const matchesSession2 = this.activeSessionId2 && data.sessionId === this.activeSessionId2;

            const isBuy = matchesSession1 || data.bType === 'BUY' || data.channel === 'BUY';
            const isSell = matchesSession2 || data.bType === 'SELL' || data.channel === 'SELL';

            // Clear session so it can't match again
            if (isBuy) this.activeSessionId1 = null;
            if (isSell) this.activeSessionId2 = null;

            setTimeout(() => {
                let updateState = {};

                if (isBuy) {
                    updateState.im_in_game_1 = false;
                    updateState.isCashingOut1 = false;
                    updateState.isPlacingBet1 = false;
                    updateState.isLoadingBet1 = false;
                    updateState.buyDisabled = false;
                    updateState.buyButtonText = this.state.auto ? "Automatic" : 'Buy';
                    this.betStartTime1 = null;
                    this.betDuration1 = 0;
                    this._cashingOut1 = false;

                    if (this.state.engine) {
                        this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 1);
                    }
                }

                if (isSell) {
                    updateState.im_in_game_2 = false;
                    updateState.isCashingOut2 = false;
                    updateState.isPlacingBet2 = false;
                    updateState.isLoadingBet2 = false;
                    updateState.sellDisabled = false;
                    updateState.sellButtonText = 'Sell';
                    this.betStartTime2 = null;
                    this.betDuration2 = 0;
                    this._cashingOut2 = false;

                    if (this.state.engine) {
                        this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 2);
                    }
                }

                this.setState(updateState);

                // === WIN / LOSS NOTIFICATION ONLY (no cleanup) ===
                if (data.won > 0) {
                    this.state.engine.trigger.emit('visual_profit', {
                        mult: parseFloat(data.exitPrice),
                        amount: data.won + data.amount,
                        type: data.bType ? data.bType.toLowerCase() : "buy",
                        username: "Me"
                    });

                    this.setState({
                        showWinNotification: true,
                        winAmount: forceSatoshiFormat(data.won + data.amount)
                    });
                    playWinSound();

                    setTimeout(() => {
                        if (this._isMounted) this.setState({ showWinNotification: false });
                    }, 5000);
                } else if (data.amount) {
                    sendNotfication("You Have Lost Kes " + forceSatoshiFormat(data.amount), 'danger', 'top-center');
                }
            }, 100);
        }
    }


    startTimerInterval() {
        if (this._isMounted) {
            // Clear any existing interval first
            if (this.buttonProgressInterval) {
                clearInterval(this.buttonProgressInterval);
                this.buttonProgressInterval = null;
            }

            let self = this;

            this.setState({
                inputDisabled: false,
                clicked: false
            });

            // Ensure persistent start time and duration for each active bet
            if (this.state.im_in_game_1 && !this.betStartTime1) {
                this.betStartTime1 = getServerTime();
                this.betDuration1 = this.getTradeDurationMs();
            }
            if (this.state.im_in_game_2 && !this.betStartTime2) {
                this.betStartTime2 = getServerTime();
                this.betDuration2 = this.getTradeDurationMs();
            }

            let buttonProgress = setInterval(function () {
                if (!self.betStartTime1 && !self.betStartTime2) {
                    if (self.buttonProgressInterval) {
                        clearInterval(self.buttonProgressInterval);
                        self.buttonProgressInterval = null;
                    }
                    self.props.setMeToGame(false);
                    self.setDefaultButton();
                    return;   // stop further execution
                }

                let now = getServerTime();

                // Check Slot 1 (Buy) - Trigger cashout if window expires, regardless of im_in_game status
                if (self.betStartTime1) {
                    let elapsedTime1 = now - self.betStartTime1;
                    if (elapsedTime1 >= self.betDuration1) {
                        self.cashOut(1);
                    }
                }

                // Check Slot 2 (Sell)
                if (self.betStartTime2) {
                    let elapsedTime2 = now - self.betStartTime2;
                    if (elapsedTime2 >= self.betDuration2) {
                        self.cashOut(2);
                    }
                }

                let amount = self.state.amount;
                let amount2 = self.state.secondBetAmount || amount;
                let currentRate = Game['current_amount'];

                let updates = { showNext: false };

                // Slot 1 Button - Force disable only if truly active and not in finishing state
                if (self.state.im_in_game_1 && !self.state.isCashingOut1 && !self._cashingOut1) {
                    updates.buyDisabled = true;
                } else if (!self.state.im_in_game_1 && !self.state.isPlacingBet1 && !self.state.isLoadingBet1) {
                    // Proactively re-enable if trade finished or was never entered
                    updates.buyDisabled = false;
                }

                // Slot 2 Button
                if (self.state.im_in_game_2 && !self.state.isCashingOut2 && !self._cashingOut2) {
                    updates.sellDisabled = true;
                } else if (!self.state.im_in_game_2 && !self.state.isPlacingBet2 && !self.state.isLoadingBet2) {
                    updates.sellDisabled = false;
                }

                if (self._isMounted && (Object.keys(updates).length > 1)) {
                    self.setState(updates);
                }
            }.bind(this), 50);

            this.buttonProgressInterval = buttonProgress;
            this.setState({ buttonProgress: this.buttonProgressInterval });
        }
    }


    checkBustedGame() {
        if (this._isMounted) {
            let durationMs = this.getTradeDurationMs();

            // Check if we have active bets within the 30-second window
            const hasActiveBet1 = this.state.im_in_game_1 && this.betStartTime1 && (getServerTime() - this.betStartTime1 < durationMs);
            const hasActiveBet2 = this.state.im_in_game_2 && this.betStartTime2 && (getServerTime() - this.betStartTime2 < durationMs);

            if (hasActiveBet1 || hasActiveBet2) {
                // console.log(`[GAME BUSTED] Game crashed but player has active bet - keeping position active`);
            } else {
                // console.log('[GAME BUSTED] Game crashed - no active bets to preserve');
            }

            // Only reset the game status, but preserve active player positions
            // Reset synchronous cashout guards
            this._cashingOut1 = false;
            this._cashingOut2 = false;

            const stateUpdate = {
                clicked: false,
                isPlacingBet1: false,
                isPlacingBet2: false,
                buyTriggered: false,
                isCashingOut1: false,
                isCashingOut2: false
            };

            // Reset player round positions immediately upon bust so they can bet on the NEXT round 
            // even if the 30-second trade window is still visually finishing.
            stateUpdate.im_in_game_1 = false;
            stateUpdate.im_in_game_2 = false;
            stateUpdate.buyDisabled = false;
            stateUpdate.sellDisabled = false;

            this.setState(stateUpdate);

            // Independent reset of start times and graph indicators
            if (!hasActiveBet1) {
                this.betStartTime1 = null;
                this.betDuration1 = 0;
                if (this.state.engine) {
                    this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 1);
                }
            }
            if (!hasActiveBet2) {
                this.betStartTime2 = null;
                this.betDuration2 = 0;
                if (this.state.engine) {
                    this.state.engine.activeTrades = this.state.engine.activeTrades.filter(t => t.slot !== 2);
                }
            }

            // Clear resources if no active bets remain
            if (!hasActiveBet1 && !hasActiveBet2) {
                // Clear active trades
                if (this.state.engine) {
                    this.state.engine.activeTrades = [];
                }
                if (this.tradeExpiryTimers) {
                    this.tradeExpiryTimers.forEach(t => clearTimeout(t));
                    this.tradeExpiryTimers = [];
                }

                if (!this.state.holding) {
                    this.props.setMeToGame(false);
                    if (this.buttonProgressInterval) {
                        clearInterval(this.buttonProgressInterval);
                        this.buttonProgressInterval = null;
                    }
                    this.setState({ buttonProgress: null });
                    this.setDefaultButton();
                }
            }
            // If we have active bets, keep the timer running
            // The 30-second setTimeout will handle the auto-cashout
        }
    }

    isCorrectBet() {
        let { amount, payout } = this.state;

        if (!isValidNumber(amount))
            return false;

        if ((payout * 100) < 100)
            return false;

        if ((payout * 100) === 100)
            return false;

        return true;
    }

    placeBet(slot = 1) {
        if (this._isMounted) {
            let { engine } = this.state;
            engine.isHolding = false;
            if (slot === 1) {
                // Keep button text as 'Buy'
            } else {
                // Keep button text as 'Sell'
            }
            this.setBet(slot);
        }
    }

    holdBet(slot = 1) {
        if (this._isMounted) {
            let { engine } = this.state;
            engine.isHolding = true;
            if (slot === 1) {
                this.setState({ holding: true, holdingSlot: 1, im_in_game_1: false, buyDisabled: true });
            } else {
                this.setState({ holding: true, holdingSlot: 2, im_in_game_2: false, sellDisabled: true });
            }
        }
    }

    handleBuy(e) {
        if (this._isMounted) {
            let { isLogged } = this.props;

            e.preventDefault();
            e.stopPropagation();

            if (!isLogged) {
                sendNotfication("Please login to trade", 'danger', 'top-center');
                return;
            }

            if (this._clickDebounce) return;
            this._clickDebounce = true;
            setTimeout(() => { this._clickDebounce = false; }, 150);   // 150ms debounce

            if (this.state.im_in_game_1) {
                this.cashOut(1);
                return;
            }

            // Balance check
            let currentBalance = parseFloat(this.props.credit) || 0;
            if (parseFloat(this.state.amount) > currentBalance) {
                sendNotfication("Insufficient Balance", 'danger', 'top-center');
                return;
            }

            if (this.state.isPlacingBet1 || this.state.isLoadingBet1) return;

            this.setState({ isLoadingBet1: true });
            this.placeBuyOrder();
        }
    }

    placeBuyOrder() {
        if (this._isMounted) {
            this.placeBet(1);

        }
    }

    handleSell(e) {
        if (this._isMounted) {
            let { isLogged } = this.props;

            e.preventDefault();
            e.stopPropagation();

            if (!isLogged) {
                sendNotfication("Please login to trade", 'danger', 'top-center');
                return;
            }

            if (this._clickDebounce) return;
            this._clickDebounce = true;
            setTimeout(() => { this._clickDebounce = false; }, 150);

            if (this.state.im_in_game_2) {
                this.cashOut(2);
                return;
            }

            // Balance check
            let currentBalance = parseFloat(this.props.credit) || 0;
            let betAmount = parseFloat(this.state.secondBetAmount || this.state.amount);
            if (betAmount > currentBalance) {
                sendNotfication("Insufficient Balance", 'danger', 'top-center');
                return;
            }

            if (this.state.isPlacingBet2 || this.state.isLoadingBet2) return;

            this.setState({ isLoadingBet2: true });
            this.placeSellOrder();
        }
    }

    placeSellOrder() {
        if (this._isMounted) {
            this.placeBet(2);
        }
    }

    hotkeyChange() {
        if (this._isMounted) {
            if (this.state.hotkey === "OFF") {
                User['denied_hotkey'] = false;
                storage.setKey("hotkey", 'ON');
                this.setState({ hotkey: "ON" })
            }
            else {
                storage.setKey("hotkey", 'OFF');
                this.setState({ hotkey: "OFF" })
            }
        }
    }

    handleHotKey(e) {
        if (this._isMounted) {
            if (User['denied_hotkey']) {
                User['denied_hotkey'] = false;
                storage.setKey('hotkey', "OFF");
                this.setState({ hotkey: 'OFF' })
            }

            if (storage.getKey('hotkey') === 'ON') {
                var char = e.which || e.keyCode;
                if (char === 98) {
                    this.handleBuy(e);
                }
                if (char === 102) {
                    var calc = parseFloat(this.state.payout * 2);
                    var max = Math.max(1.00, calc);
                    this.setState({ payout: max.toFixed(2) })
                }
                if (char === 101) {
                    var calc = parseFloat(this.state.payout / 2);
                    var max = Math.max(1.00, calc);
                    this.setState({ payout: max.toFixed(2) })
                }

                this.handleInputChange(e);
            }
        }
    }

    setMax = (e) => {
        e.preventDefault();
        var max = 200
        if (max === null) return;

        this.setState({ amount: forceSatoshiFormat(max), secondBetAmount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
        storage.setKey('lam2', forceSatoshiFormat(max));
    };

    setMin = (e) => {
        e.preventDefault();
        this.setState({ amount: '10.00', secondBetAmount: '10.00' });
        storage.setKey('lam', '10.00');
        storage.setKey('lam2', '10.00');
    };

    multi = (e) => {
        var max = 50
        this.setState({ amount: forceSatoshiFormat(max), secondBetAmount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
        storage.setKey('lam2', forceSatoshiFormat(max));
    }

    devide = (e) => {
        var max = 100
        max = Math.max(max, 0.00000010)
        this.setState({ amount: forceSatoshiFormat(max), secondBetAmount: forceSatoshiFormat(max) });
        storage.setKey('lam', forceSatoshiFormat(max));
        storage.setKey('lam2', forceSatoshiFormat(max));
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
    }

    setActiveTab2(tab) {
        this.setState({ activeTab2: tab });
    }

    handleBetAmountClick = (amount, section) => {
        if (section === 'first') {
            this.setState({ amount: amount, secondBetAmount: amount });
            storage.setKey('lam', amount);
            storage.setKey('lam2', amount);
        } else if (section === 'second') {
            this.setState({ secondBetAmount: amount });
            storage.setKey('lam2', amount);
        }
    };

    incrementAmount = (section) => {
        if (section === 'first') {
            this.setState(prevState => {
                const next = Math.min(10000, prevState.amount + 10);
                storage.setKey('lam', next);
                storage.setKey('lam2', next);
                return { amount: next, secondBetAmount: next };
            });
        } else if (section === 'second') {
            this.setState(prevState => {
                const next = Math.min(10000, prevState.secondBetAmount + 10);
                storage.setKey('lam2', next);
                return { secondBetAmount: next };
            });
        }
    };

    decrementAmount = (section) => {
        if (section === 'first') {
            this.setState(prevState => {
                const next = Math.max(10, prevState.amount - 10);
                storage.setKey('lam', next);
                storage.setKey('lam2', next);
                return { amount: next, secondBetAmount: next };
            });
        } else if (section === 'second') {
            this.setState(prevState => {
                const next = Math.max(10, prevState.secondBetAmount - 10);
                storage.setKey('lam2', next);
                return { secondBetAmount: next };
            });
        }
    };

    incrementPayout = () => {
        this.setState(prevState => {
            const newPayout = Math.min(1000000, parseFloat(prevState.payout) + 0.01).toFixed(2);
            storage.setKey('odd', newPayout);
            return { payout: newPayout };
        });
    };

    decrementPayout = () => {
        this.setState(prevState => {
            const newPayout = Math.max(1.01, parseFloat(prevState.payout) - 0.01).toFixed(2);
            storage.setKey('odd', newPayout);
            return { payout: newPayout };
        });
    };

    renderWinNotification() {
        if (!this.state.showWinNotification) return null;

        return (
            <div className="win-notification-overlay" onClick={() => this.setState({ showWinNotification: false })}>
                <div className="win-content-horizontal animated bounceIn">
                    <div className="win-shimmer"></div>
                    <div className="confetti-container">
                        {[...Array(12)].map((_, i) => (
                            <div key={i} className={`confetti-piece confetti-${i}`}></div>
                        ))}
                    </div>
                    <div className="win-sparkles"></div>
                    <div className="win-row">
                        <div className="win-trophy-small">
                            <i className="mdi mdi-trophy-variant"></i>
                        </div>
                        <div className="win-label">WON!</div>
                        <div className="win-amount-horizontal">
                            <span className="currency">KES</span>
                            <span className="value">{this.state.winAmount}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let { amount, inputDisabled, payout, buyDisabled, buyButtonText, sellButtonText, sellDisabled, im_in_game_1, im_in_game_2, isLoadingBet1, isLoadingBet2 } = this.state;
        let { isLogged } = this.props;

        if (amount === "NaN") amount = 50.00;

        return (
            <div className="betAuto-tab" id="betbox-ui">
                {this.renderWinNotification()}
                <div className="betAuto-tab-col">
                    <div className="bet-controlar">
                        <div className="d-flex flex-md-column mobile-flex-row w-100 mt-1">
                            {/* Trade Duration Section */}
                            <div className="bet-block mobile-flex-col">
                                <span className="bet-block-label">Trade Duration</span>
                                <div className="form-spinner">
                                    <div
                                        className="spinner-btn"
                                        onClick={this.decrementDuration}
                                    >
                                        <i className="mdi mdi-minus" />
                                    </div>
                                    <div style={{ position: 'relative', flex: 1, zIndex: 1001 }}>
                                        <div
                                            className="d-flex align-items-center justify-content-center border-0 text-white font-weight-bold"
                                            style={{ height: 'auto', fontSize: '1.1rem', cursor: 'pointer', outline: 'none' }}
                                            onClick={this.toggleDurationMenu}
                                        >
                                            <span style={{ minWidth: '40px', textAlign: 'center' }}>
                                                {this.state.tradeDuration === '10s' ? '10 Sec' :
                                                    this.state.tradeDuration === '15s' ? '15 Sec' :
                                                        this.state.tradeDuration === '30s' ? '30 Sec' :
                                                            this.state.tradeDuration === '1m' ? '1 Min' : '2 Min'}
                                            </span>
                                        </div>
                                        {this.state.showDurationMenu && (
                                            <div
                                                className="custom-duration-menu responsive-dropdown"
                                                style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    marginTop: '10px',
                                                    background: '#1a202c',
                                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
                                                    zIndex: 1000,
                                                    width: '100px',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                {[
                                                    { val: '10s', label: '10 Sec' },
                                                    { val: '15s', label: '15 Sec' },
                                                    { val: '30s', label: '30 Sec' },
                                                    { val: '1m', label: '1 Min' },
                                                    // { val: '2m', label: '2 Min' }
                                                ].map(opt => (
                                                    <div
                                                        key={opt.val}
                                                        onClick={() => this.handleTradeDurationChange(opt.val)}
                                                        style={{
                                                            padding: '4px 6px',
                                                            textAlign: 'center',
                                                            cursor: 'pointer',
                                                            color: this.state.tradeDuration === opt.val ? '#10b981' : '#fff',
                                                            background: this.state.tradeDuration === opt.val ? 'rgba(16, 185, 129, 0.1)' : 'transparent',
                                                            borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
                                                            fontWeight: this.state.tradeDuration === opt.val ? 'bold' : 'normal',
                                                            fontSize: '0.8rem'
                                                        }}
                                                        onMouseOver={(e) => {
                                                            if (this.state.tradeDuration !== opt.val) {
                                                                e.target.style.background = 'rgba(255, 255, 255, 0.05)';
                                                            }
                                                        }}
                                                        onMouseOut={(e) => {
                                                            if (this.state.tradeDuration !== opt.val) {
                                                                e.target.style.background = 'transparent';
                                                            }
                                                        }}
                                                    >
                                                        {opt.label}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="spinner-btn"
                                        onClick={this.incrementDuration}
                                    >
                                        <i className="mdi mdi-plus" />
                                    </div>
                                </div>
                            </div>

                            {/* Amount Section */}
                            <div className="bet-block mobile-flex-col">
                                <span className="bet-block-label">Amount (KES)</span>
                                <div className="form-spinner">
                                    <div
                                        className="spinner-btn" style={{ width: '40px' }}
                                        onClick={() => this.decrementAmount('first')}
                                    >
                                        <i className="mdi mdi-minus" />
                                    </div>
                                    <input
                                        type="number"
                                        name="amount"
                                        value={amount}
                                        onChange={this.handleInputChange}
                                        id="spinner1"
                                    />
                                    <div
                                        className="spinner-btn" style={{ width: '40px' }}
                                        onClick={() => this.incrementAmount('first')}
                                    >
                                        <i className="mdi mdi-plus" />
                                    </div>
                                </div>
                                <div className="bets-opt-list">
                                    {[100, 200, 500, 5000].map((val) => (
                                        <button
                                            key={val}
                                            className={`btn-opt ${val === 200 || val === 5000 ? 'btn-opt-mesh' : 'btn-opt-metallic'}`}
                                            onClick={() => this.handleBetAmountClick(val, 'first')}
                                        >
                                            {val}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Action Bu ttons */}
                        <div className="button-block row mb-2">
                            <div className="col-md-12 col-6 pr-0">
                                <button
                                    className={`btn-bet-premium btn-buy-premium ${im_in_game_1 ? 'im-in-game' : ''}`}
                                    disabled={inputDisabled || buyDisabled || isLoadingBet1}
                                    onClick={this.handleBuy}
                                >
                                    {isLoadingBet1 ? (
                                        <span> <i className="mdi mdi-loading mdi-spin font-24" /></span>
                                    ) : (
                                        <span className="btn-bet-text d-flex align-items-center justify-content-center">
                                            <i className="mdi mdi-arrow-up-circle-outline mr-1"></i>
                                            {buyButtonText}
                                        </span>
                                    )}
                                </button>
                            </div>
                            <div className="col-md-12 col-6 pr-0">
                                <button
                                    className={`btn-bet-premium btn-sell-premium ${im_in_game_2 ? 'im-in-game' : ''}`}
                                    disabled={inputDisabled || sellDisabled || isLoadingBet2}
                                    onClick={this.handleSell}
                                >
                                    {isLoadingBet2 ? (
                                        <span> <i className="mdi mdi-loading mdi-spin font-24" /></span>
                                    ) : (
                                        <span className="btn-bet-text d-flex align-items-center justify-content-center">
                                            <i className="mdi mdi-arrow-down-circle-outline mr-1"></i>
                                            {sellButtonText}
                                        </span>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* <div className="mt-auto w-100 mt-2" style={{ display: 'flex', justifyContent: 'center' }}>
                        <Menus />
                    </div> */}
                </div>
            </div>
        );
    }
}

class HotKey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            effect: 'pulse'
        };
    }

    toggleModal = (e) => {
        if (e !== undefined)
            e.preventDefault();

        this.setState({ show: !this.state.show, effect: !this.state.show ? 'zoomIn' : 'zoomOut' });
    };

    render() {
        return (
            <>
                <button className={'btn btn-xs stc mt-1 pl-1'} onClick={e => this.toggleModal(e)}>
                    <i className={'cp mdi mdi-information text-info font-15'} />
                </button>
                <Modal
                    size="md"
                    centered={true}
                    backdrop="static"
                    show={this.state.show}
                    onHide={this.toggleModal}
                    aria-labelledby="help-lg-modal"
                    className={"animated " + this.state.effect}
                >
                    <Modal.Header>
                        Hot Keys
                        <button type="button" className="close p-2" onClick={e => this.toggleModal(e)}>
                            <i className={'mdi mdi-close'} />
                        </button>
                    </Modal.Header>
                    <Modal.Body closeButton className="modal-helper text-center">
                        <Row className="shortcut-helper">
                            <Col sm="12">
                                <span className="badge badge-soft-danger">B</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> BET</span>
                            </Col>
                            <Col sm="12" className="my-2">
                                <span className="badge badge-soft-danger"> E</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> HALF PAYOUT</span>
                            </Col>
                            <Col sm="12">
                                <span className="badge badge-soft-danger"> F</span>
                                <i className="mdi mdi-arrow-right align-middle"></i>
                                <span className="badge badge-soft-secondary"> DOUBLE PAYOUT</span>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

ManualBet.propTypes = {
    coin: PropTypes.string,
    im_in_game: PropTypes.bool,
    credit: PropTypes.string
};

const mapStateToProps = state => ({
    coin: state.items.coin,
    im_in_game: false,
    credit: state.items.credit
});

export default connect(mapStateToProps, { gameCoin, setWinnerText, setMeToGame, setWallet })(ManualBet);